import styled, { css } from 'styled-components';
import { BG_MIN_HEIGHT } from '../constants';

export const BackgroundFixed = styled.div<{
  scrolledValue: number;
  isSmallProfile: boolean;
}>`
  ${({ theme, scrolledValue, isSmallProfile }) => css`
    position: sticky;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 20;

    > div {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      background: ${theme.color.background.neutral.default};
      height: ${BG_MIN_HEIGHT}px;
      transition: height 0s, box-shadow 0.15s ease-in-out 0s;
      box-shadow: ${(isSmallProfile && scrolledValue >= 270) || (!isSmallProfile && scrolledValue >= 193)
        ? theme.elevation.ton2
        : ''};
    }
  `}
`;
